import { WorklistsReportDataRow } from '@/app/components/Reporting/Collaboration/WorklistsReport/types';
import { useMemo } from 'react';
import moment from 'moment/moment';
import translate from '@/app/utils/translate';

type PropsType = {
  reportName: string;
  worklistsData: WorklistsReportDataRow[];
};

export const useWorklistReportExcelAndGridData = (props: PropsType) => {
  const { reportName, worklistsData } = props;

  const excelFileName = useMemo(() => {
    const generateFilename = (type: string) => {
      return `${type}_${moment().format('YYYYMMDD')}`
        .replace(/[^a-zA-Z0-9_-]/gi, '_')
        .replace(/_{2,}/g, '_');
    };

    return generateFilename(reportName);
  }, [translate]);

  return {
    gridData: worklistsData,
    excelData: {
      fileName: excelFileName,
      current: worklistsData,
    },
  };
};
